import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FUNNEL_PAYMENT_SELECTION_STEP } from '../../constants/funnel';
import { HAS_INSTANT_DISCOUNT, BRAND_NAME, USE_PARITY, NO_DISCOUNT } from '../../constants';

import { getI18nByApp } from '../../services/i18n/selector';

import {
    doUserCartTotalCashbackAmount,
    doUserCartTotalCashbackAmountParity
} from '../../utils/cartUtils';
import { formatAmountCurrency, formatAmountParity } from '../../utils';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import ButtonContainer from './buttons/ButtonContainer';

import { RightContainer } from './FunnelRightContainerStyle';

const FunnelRightContainer = ({
    partnerId,
    userInfo,
    userCart,
    stateOfTransaction,
    setStateOfTransaction,
    amountCashback,
    cartTotalValue,
    paymentType,
    order,
    kycNeeded,
    i18n,
    i18nMulti
}) => {
    const getLabelText = () => {
        if (HAS_INSTANT_DISCOUNT) {
            return i18n.INSTANT_DISCOUNT;
        }

        return convertHtmlToReactDomWithParams(
            getI18nByApp(i18nMulti, 'page.MERCHANTCARD.EBON_SELECTOR.DISCOUNT'),
            BRAND_NAME
        );
    };

    return (
        <RightContainer id="rightContainer">
            <div className="rightInnerContainer bordered ebonRecap">
                <h3>{`${i18n.RECAPITULATIF}`}</h3>
                {userCart.map((ebons, i) => (
                    <div key={i}>
                        <p>
                            {convertHtmlToReactDomWithParams(
                                getI18nByApp(i18nMulti, 'page.EBON.BON_ACHAT_LIGNE'),
                                ebons.partnerName,
                                formatAmountCurrency(ebons.value)
                            )}
                        </p>
                        <div style={{ minWidth: '110px' }}>
                            <span
                                style={{
                                    justifyContent: 'flex-end',
                                    flex: 2
                                }}>
                                x {ebons.quantity}
                            </span>{' '}
                            <span> = </span>{' '}
                            <span
                                style={{
                                    justifyContent: 'flex-end',
                                    flex: 2
                                }}>
                                {formatAmountCurrency(ebons.quantity * ebons.value)}
                            </span>
                        </div>
                    </div>
                ))}
            </div>

            <div className="rightInnerContainer bordered-no-top ebonTotal">
                <div className="shiping">
                    <p>{`${i18n.LIVRAISON}`}</p>
                    <div>
                        <span>{`${i18n.GRATUITE}`}</span>
                    </div>
                </div>

                {!NO_DISCOUNT && (
                    <div className="cashback">
                        <p>{getLabelText()}</p>
                        <div>
                            <span>
                                {USE_PARITY
                                    ? formatAmountParity(
                                          doUserCartTotalCashbackAmountParity(
                                              userCart,
                                              amountCashback
                                          )
                                      )
                                    : formatAmountCurrency(
                                          doUserCartTotalCashbackAmount(userCart, amountCashback)
                                      )}
                            </span>
                        </div>
                    </div>
                )}

                <div className="total">
                    <p>{`${i18n.TOTAL_VALUE}`}</p>
                    <div>
                        <span>{formatAmountCurrency(cartTotalValue)}</span>
                    </div>
                </div>
            </div>

            {stateOfTransaction === FUNNEL_PAYMENT_SELECTION_STEP && (
                <ButtonContainer
                    paymentType={paymentType}
                    setStateOfTransaction={setStateOfTransaction}
                    cartTotalValue={cartTotalValue}
                    userInfo={userInfo}
                    partnerId={partnerId}
                    order={order}
                    kycNeeded={kycNeeded}
                />
            )}
        </RightContainer>
    );
};

FunnelRightContainer.propTypes = {
    partnerId: PropTypes.number,
    userInfo: PropTypes.object,
    userCart: PropTypes.array,
    stateOfTransaction: PropTypes.string,
    setStateOfTransaction: PropTypes.func,
    amountCashback: PropTypes.number,
    cartTotalValue: PropTypes.number,
    paymentType: PropTypes.string,
    order: PropTypes.object,
    kycNeeded: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON,
        i18nMulti: state.i18n
    };
};

export default connect(mapStateToProps)(FunnelRightContainer);



// WEBPACK FOOTER //
// ./src/components/funnel/FunnelRightContainer.js